import { useState } from 'react';
import './ImageGallery.css';

const ImageGallery = ({ images, margin = "2" }) => {
  const [current, setCurrent] = useState(0);

  return (
    <div className={`image-gallery m-${margin}`}>
      {/* تصویر اصلی */}
      <div
        className="main-image-wrapper d-flex align-items-center justify-content-center mb-2"
        style={{
          width: "70%",
          maxHeight: "600px",
          overflow: "hidden",
          borderRadius: "12px",
          background: "#f8f8f8",
        }}
      >
        <img
          src={images[current]}
          alt=""
          className="main-img"
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
            objectPosition: "center center",
          }}
        />
      </div>

      {/* تصاویر بندانگشتی */}
      <div className="d-flex flex-wrap justify-content-start">
        {images.map((src, i) => (
          <img
            key={i}
            src={src}
            className={`img-thumbnail me-2 mb-2 thumb ${
              current === i ? "active" : ""
            }`}
            onClick={() => setCurrent(i)}
            style={{
              cursor: "pointer",
              width: "70px",
              height: "70px",
              objectFit: "cover",
              border:
                current === i ? "2px solid var(--bs-primary)" : "1px solid #ccc",
              borderRadius: "8px",
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageGallery;
